var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "align-self-stretch flex-fill d-flex align-items-center justify-content-center",
    },
    [
      _c("div", { staticClass: "text-center" }, [
        _c("h6", [_vm._v("Messages have not been generated yet")]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary my-4",
            on: {
              click: function ($event) {
                return _vm.$emit("generate")
              },
            },
          },
          [_c("i", { staticClass: "fas fa-cloud-rain" })]
        ),
        _vm._v(" "),
        _c("div", [_vm._v("Press the button to do it now")]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }